import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtramButtonComponent } from '../shared/components/atram-button/atram-button.component';
import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CryptoService } from './services/crypto.service';
import { FundsPortalService } from './services/funds-portal.service';
import { HttpRequestService } from './services/http-service.service';
import { LocalStorageService } from './services/local-storage.service';
import { LoaderInterceptor } from './interceptors/loader.interceptor';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent
  ]
})
export class CoreModule {
  public static forRoot(environment: any): ModuleWithProviders<any> {

    return {
      ngModule: CoreModule,
      providers: [{
            provide: 'environment', 
            useValue: environment
        }
      ]
    };
  }
 }
export * from './services/crypto.service';
export * from './services/funds-portal.service';
export * from './services/http-service.service';
export * from './services/local-storage.service';
export * from './services/loader.service';
export * from './auth/auth.service';
export * from './interceptors/loader.interceptor';
export * from './models/Options.model';